// GH-794 / GH-939: shared pieces of the optional statistics-permission consent
// start, used by Settings → Connected social accounts and by the in-app
// TikTok statistics notice so both issue the exact same account-pinned start.
import { api } from '../services/api/client.js';

export const SETTINGS_ACCOUNTS_PATH = '/app/settings?tab=accounts';

// Platforms whose provider app can actually request the statistics scopes
// (GET /social/accounts → availableProviders[].metricsConsentAvailable).
export function metricsConsentPlatformsFrom(response) {
  const payload = response?.data && typeof response.data === 'object' ? response.data : response;
  return new Set((Array.isArray(payload?.availableProviders) ? payload.availableProviders : [])
    .filter(provider => provider.metricsConsentAvailable === true)
    .map(provider => String(provider.platform || '').toLowerCase())
    .filter(Boolean));
}

// A connected account on a platform whose app can request statistics consent.
export function canRequestMetricsConsent(account, consentPlatforms) {
  return Boolean(account) && consentPlatforms.has(String(account.platform || '').toLowerCase())
    && ['connected', 'active'].includes(account.status);
}

// …whose active token is known to lack the statistics scopes.
export function metricsConsentMissing(account, consentPlatforms) {
  return canRequestMetricsConsent(account, consentPlatforms) && account.metricsScopesGranted === false;
}

// A connect started outside onboarding must return to Settings. Clear any STALE
// OAuth-return flags left over from a prior onboarding / assistant / activation
// flow — otherwise App.jsx's callback router sees the old flag and bounces the
// user to /onboarding (or /preview) on the FIRST return. (Literals mirror App.jsx.)
export function clearStaleOAuthReturnFlags() {
  try {
    window.localStorage.removeItem('dathent_onboarding_social_oauth_return');
    window.localStorage.removeItem('dathent_assistant_social_oauth_return');
    window.localStorage.removeItem('activation_return_to_first_post');
  } catch (_) { /* private mode */ }
}

// The same start Settings issues for "Statistics permissions": a reconnect of
// this existing account with the optional metrics scopes, pinned to its id,
// returning to Settings where the OAuth outcome is explained.
export function startMetricsConsent(account) {
  clearStaleOAuthReturnFlags();
  return api.socialAccounts.connect(String(account.platform || '').toLowerCase(), {
    returnPath: SETTINGS_ACCOUNTS_PATH,
    overageAck: false,
    reconnect: true,
    metrics: true,
    accountId: account.id,
  });
}
